/* SACCATA — drawers, AJAX cart, predictive search, variant picker and scroll reveals.
   No dependencies. Everything degrades to plain links and form posts without JavaScript. */
(function () {
  'use strict';

  var config = window.SACCATA || {};
  var routes = config.routes || {};
  var strings = config.strings || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- drawers (native <dialog>) ---------- */

  function drawerById(id) {
    return document.getElementById(id);
  }

  function openDrawer(id) {
    var drawer = drawerById(id);
    if (!drawer || drawer.open) return;

    document.querySelectorAll('dialog.drawer[open]').forEach(function (other) {
      other.classList.remove('is-open');
      other.close();
    });

    drawer.showModal();
    document.documentElement.style.overflow = 'hidden';
    // Next frame, so the opening transition runs from the off-screen position.
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      var autofocus = drawer.querySelector('[data-drawer-autofocus]');
      if (autofocus) autofocus.focus();
    });
    drawer.dispatchEvent(new CustomEvent('drawer:open'));
  }

  function closeDrawer(drawer) {
    if (!drawer || !drawer.open) return;
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';

    if (reduceMotion) {
      drawer.close();
      return;
    }
    var panel = drawer.querySelector('.drawer__panel');
    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      drawer.close();
    };
    panel.addEventListener('transitionend', finish, { once: true });
    // Fallback in case the transition never fires (hidden tab, interrupted animation).
    setTimeout(finish, 700);
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      event.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }
    var closer = event.target.closest('[data-drawer-close]');
    if (closer) {
      event.preventDefault();
      closeDrawer(closer.closest('dialog.drawer'));
    }
  });

  // Esc: let the browser's own cancel event drive the animated close.
  document.querySelectorAll('dialog.drawer').forEach(function (drawer) {
    drawer.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeDrawer(drawer);
    });
  });

  /* ---------- cart ---------- */

  function sectionHtml(html, selector) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var found = parsed.querySelector(selector);
    return found ? found.innerHTML : null;
  }

  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (key) {
      var target = document.querySelector('[data-section="' + key + '"]');
      var inner = sections[key] && sectionHtml(sections[key], '[data-section="' + key + '"]');
      if (target && inner !== null) target.innerHTML = inner;
    });
  }

  function cartRequest(url, body, onDone) {
    body.sections = 'cart-drawer,cart-icon-bubble';
    body.sections_url = window.location.pathname;

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          if (onDone) onDone(result.data.description || result.data.message || strings.cartError);
          return;
        }
        applySections(result.data.sections);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: result.data }));
        if (onDone) onDone(null);
      })
      .catch(function () {
        if (onDone) onDone(strings.cartError);
      });
  }

  // Add to cart from any product form.
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-product-form]');
    if (!form) return;

    var variantInput = form.querySelector('[name="id"]');
    var status = form.querySelector('[data-form-status]');
    if (!variantInput || !variantInput.value) {
      event.preventDefault();
      if (status) {
        status.textContent = strings.chooseOption;
        status.classList.add('form-status--error');
      }
      var firstSelect = form.closest('[data-product]').querySelector('select[data-option-select]');
      if (firstSelect) firstSelect.focus();
      return;
    }

    event.preventDefault();
    var button = form.querySelector('[type="submit"]');
    if (button) button.setAttribute('disabled', 'disabled');
    if (status) {
      status.textContent = '';
      status.classList.remove('form-status--error');
    }

    cartRequest(
      routes.cartAdd + '.js',
      { items: [{ id: variantInput.value, quantity: Number(form.quantity ? form.quantity.value : 1) || 1 }] },
      function (error) {
        if (button) button.removeAttribute('disabled');
        if (error) {
          if (status) {
            status.textContent = error;
            status.classList.add('form-status--error');
          }
          return;
        }
        openDrawer('cart-drawer');
      }
    );
  });

  // Change quantity or remove a line, in the drawer and on the cart page.
  document.addEventListener('click', function (event) {
    var control = event.target.closest('[data-cart-change]');
    if (!control) return;
    event.preventDefault();
    cartRequest(
      routes.cartChange + '.js',
      { line: Number(control.getAttribute('data-line')), quantity: Number(control.getAttribute('data-cart-change')) },
      null
    );
  });

  /* ---------- predictive search ---------- */

  var searchDrawer = drawerById('search-drawer');
  if (searchDrawer) {
    var input = searchDrawer.querySelector('[data-search-input]');
    var results = searchDrawer.querySelector('[data-search-results]');
    var timer = null;
    var lastQuery = '';

    var render = function () {
      var term = input.value.trim();
      if (term === lastQuery) return;
      lastQuery = term;

      if (term.length < 2) {
        results.innerHTML = '';
        return;
      }
      var url =
        routes.predictiveSearch +
        '?q=' +
        encodeURIComponent(term) +
        '&resources[type]=product&resources[limit]=' +
        (results.getAttribute('data-limit') || 6) +
        '&section_id=predictive-search';

      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var inner = sectionHtml(html, '[data-section="predictive-search"]');
          results.innerHTML = inner === null ? '' : inner;
        })
        .catch(function () {
          results.innerHTML = '';
        });
    };

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(render, 200);
    });
  }

  /* ---------- product: options, price and gallery ---------- */

  document.querySelectorAll('[data-product]').forEach(function (product) {
    var dataTag = product.querySelector('[data-variants]');
    if (!dataTag) return;

    var variants = JSON.parse(dataTag.textContent);
    var selects = Array.prototype.slice.call(product.querySelectorAll('[data-option-select]'));
    var swatches = Array.prototype.slice.call(product.querySelectorAll('[data-option-swatch]'));
    var variantInput = product.querySelector('[name="id"]');
    var priceTarget = product.querySelector('[data-price]');
    var submit = product.querySelector('[data-product-form] [type="submit"]');
    var colorLabel = product.querySelector('[data-color-value]');

    function chosen() {
      var values = {};
      selects.forEach(function (select) {
        values[select.getAttribute('data-option-select')] = select.value;
      });
      swatches
        .filter(function (button) {
          return button.getAttribute('aria-pressed') === 'true';
        })
        .forEach(function (button) {
          values[button.getAttribute('data-option-swatch')] = button.getAttribute('data-value');
        });
      return values;
    }

    function update() {
      var values = chosen();
      var positions = Object.keys(values);
      var complete = positions.every(function (position) {
        return values[position];
      });

      var match = complete
        ? variants.filter(function (variant) {
            return positions.every(function (position) {
              return variant.options[Number(position) - 1] === values[position];
            });
          })[0]
        : null;

      if (variantInput) variantInput.value = match && match.available ? match.id : '';
      if (priceTarget && match && match.price_formatted) priceTarget.innerHTML = match.price_formatted;
      if (colorLabel && values['1'] && product.getAttribute('data-color-position') === '1') {
        colorLabel.textContent = values['1'];
      }

      if (submit) {
        if (!complete) {
          submit.textContent = submit.getAttribute('data-label');
          submit.removeAttribute('disabled');
        } else if (!match || !match.available) {
          submit.textContent = strings.soldOut;
          submit.setAttribute('disabled', 'disabled');
        } else {
          submit.textContent = submit.getAttribute('data-label');
          submit.removeAttribute('disabled');
        }
      }
    }

    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        var status = product.querySelector('[data-form-status]');
        if (status) {
          status.textContent = '';
          status.classList.remove('form-status--error');
        }
        update();
      });
    });

    swatches.forEach(function (button) {
      button.addEventListener('click', function () {
        var group = button.getAttribute('data-option-swatch');
        swatches
          .filter(function (other) {
            return other.getAttribute('data-option-swatch') === group;
          })
          .forEach(function (other) {
            other.setAttribute('aria-pressed', String(other === button));
          });
        if (colorLabel) colorLabel.textContent = button.getAttribute('data-value');
        update();
      });
    });

    update();
  });

  /* ---------- scroll reveals ---------- */

  var revealTargets = document.querySelectorAll('[data-reveal]');
  if (revealTargets.length && 'IntersectionObserver' in window && !reduceMotion) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px' }
    );

    revealTargets.forEach(function (target) {
      // Anything already on screen stays as rendered, so nothing waits for JavaScript.
      if (target.getBoundingClientRect().top < window.innerHeight) {
        target.classList.add('is-revealed');
      } else {
        observer.observe(target);
      }
    });
  } else {
    revealTargets.forEach(function (target) {
      target.classList.add('is-revealed');
    });
  }
})();
